import React from 'react';
import { SocketProvider } from './SocketContext';
import GlobalListeners from '../components/layouts/GlobalListeners';

/**
 * A component to centralize all application-wide context providers.
 * This helps to avoid deep nesting ("Provider Hell") in App.jsx.
 */
const AppProviders = ({ children }) => {
  // Todos los providers (AuthProvider, DataProvider, CartProvider, MusicPlayerProvider, HolidaysProvider)
  // han sido eliminados y reemplazados por stores de Zustand.
  // SocketProvider es el único que queda para gestionar la instancia del socket.
  return (
    <SocketProvider>
      <GlobalListeners />
      {children}
    </SocketProvider>
  );
};

export default AppProviders;
